import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WashOutComponent } from './wash-out.component';



@NgModule({
  declarations: [
    WashOutComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    WashOutComponent
  ]
})
export class WashOutModule { }
